import memoize from "memoize";

const dobnowJobType = (code: string) => {
  const jobTypeByCode: { [key: string]: string } = {
    A1: "Alteration Type I",
    A2: "Alteration Type II",
    A3: "Alteration Type III",
    NB: "New Building",
    DM: "Demolition",
    PA: "Place of Assembly",
    SC: "Subdivision Condominiums",
    SI: "Subdivision Improved",
  };
  return jobTypeByCode[code] || code;
};

export default memoize(dobnowJobType);
